import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Story } from "./components/Story";
import { Footer } from "./components/Footer";
import { GaleriePage } from "./components/GaleriePage";
import { GiftVoucherPage } from "./components/GiftVoucherPage";
import { BackofficePage } from "./components/BackofficePage";
import useReveal from "./lib/useReveal";

const ScrollToHash = () => {
    const { hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
            }
        }
    }, [hash]);
    return null;
};

const Landing = () => {
    useReveal();
    return (
        <div className="App font-sans bg-[#F9F8F6] text-[#2C1E16]">
            <ScrollToHash />
            <Navbar />
            <main>
                <Hero />
                <Story />
            </main>
            <Footer />
        </div>
    );
};

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/galerie" element={<GaleriePage />} />
                <Route path="/bon-cadeau" element={<GiftVoucherPage />} />
                <Route path="/backoffice" element={<BackofficePage />} />
            </Routes>
            <Toaster
                position="top-center"
                richColors
                closeButton
                toastOptions={{ style: { fontFamily: "Manrope, sans-serif" } }}
            />
        </BrowserRouter>
    );
}

export default App;
